import React from 'react';
import { Row, Card, Alert, Form, Button } from 'react-bootstrap';
import _ from 'lodash';
import { Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment';
import {
  isCPF,
  isPhone,
  formatToCPF,
  formatToPhone,
  isDate
} from 'brazilian-values';

import fiterAPI from '../fiterAPI';

const schema = yup.object({
  name: yup.string().required(),
  birthday: yup.string().required(),
  cpf: yup.string().required(),
  email: yup
    .string()
    .email('Email inválido.')
    .required(),
  phone: yup.string().required(),
  courseId: yup.string().required(),
  password: yup
    .string()
    .required('Campo obrigatório.')
    .min(6, 'Senha muito curta.')
});

const customFormatToDate = str => {
  if (str && (str.length === 2 || str.length === 5)) return `${str}/`;
  if (str && str.length > 10) return str.slice(0, -1);
  return str;
};

class Signup extends React.Component {
  constructor() {
    super();
    this.state = {
      name: '',
      birthday: '',
      cpf: '',
      email: '',
      phone: '',
      courseId: '',
      currentUser: '',
      password: '',
      errorMessage: '',
      loading: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
  }

  onSubmit = async newValues => {
    try {
      this.setState({ loading: true });
      const dateMomentObject = moment(newValues.birthday, 'DD/MM/YYYY');
      const dateObject = dateMomentObject.toDate();

      await fiterAPI.signup(_.assign({}, newValues, { birthday: dateObject }));
      await this.props.setCurrentUser();
      this.setState({ errorMessage: '' });
    } catch (err) {
      const errorMessage = _.get(
        err,
        'message',
        'Ocorreu um erro, verifique suas credenciais.'
      );
      this.setState({ errorMessage });
    } finally {
      this.setState({ loading: false });
    }
  };

  onChangeField(event, field) {
    const value = _.get(event, 'target.value');
    this.setState({ [field]: value });
  }

  render() {
    const { courses = {} } = this.props;
    const { institutions = {} } = this.props;
    const { errorMessage, loading } = this.state;
    return (
      <Row className="justify-content-center mt-5 mb-5">
        <Card style={{ width: '36rem' }} className="shadow">
          <Card.Body>
            <Card.Title>Cadastre-se</Card.Title>
            <Formik
              validationSchema={schema}
              onSubmit={this.onSubmit}
              initialValues={{ ...this.state }}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                setFieldValue,
                errors
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Form.Group controlId="formBasicName">
                    <Form.Label>Nome Completo</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={values.name && !!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      Valor inválido
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="formBasicBirthday">
                    <Form.Label>Data de nascimento</Form.Label>
                    <Form.Control
                      type="text"
                      name="birthday"
                      value={values.birthday}
                      onChange={event => {
                        const value = _.get(event, 'target.value');
                        setFieldValue(
                          'birthday',
                          customFormatToDate(value.toString())
                        );
                      }}
                      isInvalid={values.birthday && !isDate(values.birthday)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Valor inválido
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="formBasicCPF">
                    <Form.Label>CPF</Form.Label>
                    <Form.Control
                      type="text"
                      name="cpf"
                      placeholder="Insira apenas os números"
                      value={values.cpf}
                      onChange={event => {
                        const value = _.get(event, 'target.value');
                        setFieldValue('cpf', formatToCPF(value.toString()));
                      }}
                      isInvalid={values.cpf && !isCPF(values.cpf)}
                    />
                    <Form.Control.Feedback type="invalid">
                      CPF inválido
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      isInvalid={values.email && !!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      Email inválido
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="formBasicPhone">
                    <Form.Label>Telefone</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      placeholder="Insira apenas os números com DDD"
                      value={values.phone}
                      onChange={event => {
                        const value = _.get(event, 'target.value');
                        setFieldValue('phone', formatToPhone(value.toString()));
                      }}
                      isInvalid={values.phone && !isPhone(values.phone)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Telefone inválido
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="courseId">
                    <Form.Label>Selecione a instituição/empresa</Form.Label>
                    <Form.Control as="select" onChange={handleChange}>
                      <option>Escolher</option>
                      {_.map(courses, course => (
                        <option value={course.id} key={course.id}>
                          {course.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="courseId">
                    <Form.Label>Selecione o curso</Form.Label>
                    <Form.Control as="select" onChange={handleChange}>
                      <option>Escolher</option>
                      {_.map(courses, course => (
                        <option value={course.id} key={course.id}>
                          {course.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="formBasicPassword">
                    <Form.Label>Senha</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={values.password && !!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {errorMessage ? (
                    <Alert variant="danger">{errorMessage}</Alert>
                  ) : (
                    <></>
                  )}

                  {!loading ? (
                    <Button variant="primary" type="submit" disabled={loading}>
                      Enviar
                    </Button>
                  ) : (
                    <div className="spinner-border" />
                  )}
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Row>
    );
  }
}

export default Signup;
